
































import { Vue, Component, Prop } from "vue-property-decorator";
import formatService from "@/services/format";
import PositionsData from "./PositionsData";

@Component
export default class IncomeForm extends Vue {
    @Prop() private value!: number;

    private open: boolean = false;
    private positions = PositionsData;
    private positionName?: string|boolean;

    constructor(props: any) {
        super(props);
        const firstPosition = this.positions[0];
        this.handleSelectPosition(firstPosition);
    }

    private getValue () {
        const formattedValue = this.value === 0 ? '' : formatService.price(this.value);

        return "₽ " + formattedValue;
    }

    private handleChange ($event: any) {
        this.change($event.target.value.replace(/[^\d]/gm, ''));
        this.positionName = false;
    }

    private change (value: string) {
        this.$emit('input', value);
    }

    handleOpen () {
        this.open = true;
    }

    handleClose () {
        this.open = false;
    }

    handleSelectPosition(position: any) {
        this.positionName = position.name;
        this.change(position.income + '');
    }
}
